// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['mi_NZ']  = { // eslint-disable-line import/no-commonjs
  name: 'mi_NZ',
  day: {
    abbrev: ['Ta', 'Ma', 'Tū', 'We', 'Tāi', 'Pa', 'Hā'],
    full: [
      'Rātapu',
      'Mane',
      'Tūrei',
      'Wenerei',
      'Tāite',
      'Paraire',
      'Hātarei'
    ]
  },
  month: {
    abbrev: [
      'Hān',
      'Pēp',
      'Māe',
      'Āpe',
      'Mei',
      'Hun',
      'Hūr',
      'Āku',
      'Hep',
      'Oke',
      'Noe',
      'Tīh'
    ],
    full: [
      'Kohi-tātea',
      'Hui-tanguru',
      'Poutū-te-rangi',
      'Paenga-whāwhā',
      'Haratua',
      'Pipiri',
      'Hōngoingoi',
      'Here-turi-kōkā',
      'Mahuru',
      'Whiringa-ā-nuku',
      'Whiringa-ā-rangi',
      'Hakihea'
    ]
  },
  meridiem: ['ahau', 'pm'],
  date: '%d/%m/%y',
  time24: '%T',
  dateTime: 'Te %A, te %d o %B, %Y %T %Z',
  time12: '',
  full: 'Te %A, te %d o %B, %Y %T %Z'
}

